import script from "./ThresholdSettingsComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./ThresholdSettingsComponent.vue?vue&type=script&setup=true&lang=js"

import "./ThresholdSettingsComponent.vue?vue&type=style&index=0&id=5a22eeaf&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5a22eeaf"]])

export default __exports__